import React, { useEffect, useState } from 'react';
import Header1 from "../Images/Home/1.jpg";
import Header2 from "../Images/Home/2.jpg";
import Header3 from "../Images/Home/3.jpg";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Images/Home/boat.png";
import Ship from "../Images/Home/ship.png";
import Footer from '../Components/footer';
import Icon360 from '../Images/Home/360-icon-sm.png';
import UltimateVacation from "../Images/Home/D943_212_048_1200.jpg";
import nimar from "../Images/Home/nimar.jpg";
import cecho from "../Images/Home/cecho.jpg";
import kite from "../Images/Home/kite.jpg";
import wreck from "../Images/Home/wreck.jpg";
import { onAuthStateChanged, signOut } from "firebase/auth";

export default function Booking(props) {

    const [User, SetUser] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        onAuthStateChanged(props.auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                SetUser(user);
                const uid = user.uid;
                // ...
                console.log("uid", uid)
            } else {
                // User is signed out
                // ...
                console.log("user is logged out")
            }
        });
    }, [])

    function signout() {
        signOut(props.auth).then(() => {
            window.location.reload(false);
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    }

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-dark nav-bg fixed-top">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand"><img src={Logo} alt="Logo" width="30" height="30" /></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 navbar-nav-scroll">
                            <li className="nav-item">
                                <Link to="/" className="nav-link active" aria-current="page">Home</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Boats
                                </a>
                                <ul className="dropdown-menu">
                                    <li><Link to="/cechoii" className="dropdown-item">C-ECHO II</Link></li>
                                    <li><Link to="/nimar" className="dropdown-item">Nimar</Link></li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <Link to="/routes" className="nav-link">Routes</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/news" className="nav-link">News</Link>
                            </li>
                            {User !== '' ? <li className="nav-item">
                                <Link to="/contact" className="nav-link">Book a boat</Link>
                            </li> : null}
                        </ul>
                        <ul className="navbar-nav navbar-nav-scroll">
                            {User !== '' ? <li className="nav-item">
                                <Link to="/bookings" className="nav-link">Bookings</Link>
                            </li> : null}
                            <li className="nav-item">
                                {User === '' ? <Link to="/login" className="nav-link">Login</Link> : null}
                            </li>
                            <li className="nav-item">
                                {User === '' ? <Link to="/signup" className="nav-link">Register</Link> : null}
                            </li>
                            <li>
                                {User !== '' ? <Link to="/" className="nav-link" onClick={signout}>Logout</Link> : null}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <section>
                <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="false">
                    <div className="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active"
                            aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1"
                            aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2"
                            aria-label="Slide 3"></button>
                    </div>
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src={Header1} className="header" alt="shark" style={{ objectFit: "cover", objectPosition: "center" }} />
                            <div className="carousel-caption d-none d-md-block">
                                <h5>Dive into the Depths</h5>
                                <p>Explore the fascinating underwater world with us</p>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img src={Header2} className="header" alt="reef" style={{ objectFit: "cover", objectPosition: "center" }} />
                            <div className="carousel-caption d-none d-md-block">
                                <h5>Unwind, Relax, Recharge</h5>
                                <p>Immerse yourself in ocean tranquility with our packages.</p>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img src={Header3} className="header" alt="coast" style={{ objectFit: "cover", objectPosition: "center" }} />
                            <div className="carousel-caption d-none d-md-block">
                                <h5>Feel the Elegance</h5>
                                <p>Experience your sea trip at its finest</p>
                            </div>
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions"
                        data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions"
                        data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </section>

            <section className="d-flex flex-column justify-content-lg-around py-5 flex-lg-row align-items-center">
                <div className="px-5">
                    <h1 className='titleHome'>Redefine the way you dive</h1>
                    <p>
                        At Red Sea Explorers we offer an unbeatable liveaboard experience with diving opportunities all over the
                        Red Sea. Our routes stretch from Sinai to the Sudan and encompass all that's in between.
                    </p>
                    <p>
                        With such diverse dive sites on our itineraries, we cater for recreational diving of all levels as well
                        as technical diving. With a keen interest in technical diving operations, we encourage and support
                        research and exploration projects onboard.
                    </p>
                </div>
                <div className="px-5">
                    <iframe src="https://www.youtube.com/embed/Dty2QJGcVZs" title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>
            </section>

            <section className="d-flex flex-column flex-lg-row justify-content-around py-5 text-white" style={{ backgroundColor: "#0e2a47" }}>
                <div className="px-5">
                    <h1>Upcoming trips</h1>
                    <p>
                        Watch this space for updates on notable trips and special offers.
                    </p>
                </div>
                <div className="px-5">
                    <article className="bg-white text-black d-flex flex-column flex-lg-row justify-content-lg-between justify-content-center align-items-center upcoming p-3 my-3 rounded-2">
                        <div className="d-flex flex-column trip">
                            <span className="fw-bold">North Class</span>
                            <span>M/Y C-echo II</span>
                        </div>
                        <div className="d-flex flex-column trip">
                            <img src={Ship} className="ship" alt="ship" />
                            <span>6 places left</span>
                        </div>
                        <div className="d-flex align-items-center trip">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                <path
                                    d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 13V15H6V13H8ZM13 13V15H11V13H13ZM18 13V15H16V13H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
                                    fill="#000"></path>
                            </svg>
                            <span className="px-3">23 Apr</span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                <path
                                    d="M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z"
                                    fill="#000"></path>
                            </svg>
                            <span className="px-3">30 Apr</span>
                        </div>
                        <div className="trip">
                            <a href="contact.html"><button className="button2">
                                Book now
                            </button></a>
                        </div>
                    </article>
                    <article className="bg-white text-black d-flex flex-column flex-lg-row justify-content-lg-between justify-content-center align-items-center upcoming p-3 my-3 rounded-2 ">
                        <div className="d-flex flex-column trip">
                            <span className="fw-bold">Great South</span>
                            <span>M/Y Nimar</span>
                        </div>
                        <div className="d-flex flex-column trip">
                            <img src={Ship} alt="ship" />
                            <span>11 places left</span>
                        </div>
                        <div className="d-flex align-items-center trip">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                <path
                                    d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 13V15H6V13H8ZM13 13V15H11V13H13ZM18 13V15H16V13H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
                                    fill="#000"></path>
                            </svg>
                            <span className="px-3">28 Janr</span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                <path
                                    d="M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z"
                                    fill="#000"></path>
                            </svg>
                            <span className="px-3">5 Feb</span>
                        </div>
                        <div className="trip">
                            <a href="contact.html"><button className="button2">
                                Book now
                            </button></a>
                        </div>
                    </article>
                    <article className="bg-white text-black d-flex flex-column flex-lg-row justify-content-lg-between justify-content-center align-items-center upcoming p-3 my-3 rounded-2">
                        <div className="d-flex flex-column trip">
                            <span className="fw-bold">WRECKS</span>
                            <span>M/Y C-echo II</span>
                        </div>
                        <div className="d-flex flex-column trip">
                            <img src={Ship} alt="ship" />
                            <span>3 places left</span>
                        </div>
                        <div className="d-flex align-items-center trip">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                <path
                                    d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 13V15H6V13H8ZM13 13V15H11V13H13ZM18 13V15H16V13H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
                                    fill="#000"></path>
                            </svg>
                            <span className="px-3">7 Apr</span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                <path
                                    d="M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z"
                                    fill="#000"></path>
                            </svg>
                            <span className="px-3">14 Apr</span>
                        </div>
                        <div className="trip">
                            <a href="contact.html"><button className="button2">
                                Book now
                            </button></a>
                        </div>
                    </article>
                </div>
            </section>

            <section>
                <h1 className="text-center py-5">Our Fleet</h1>
                <article className="d-flex flex-column flex-lg-row justify-content-lg-around justify-content-center align-items-center pb-5">
                    <div style={{ backgroundImage: `url(${nimar})` }}
                        className="card-index fleet p-3 d-flex flex-column flex-lg-row align-items-end justify-content-between text-white"
                        onclick="window.open('nimar.html','_self')">
                        <span className="display-4">M/Y Nimar</span>
                        <div className="d-flex align-items-center">
                            <img className="px-4" src={Icon360} alt="360" />
                            <a href="contact.html" style={{ textDecoration: "none" }}><span style={{ fontSize: "26px" }} className="text-white">Schedule</span></a>

                        </div>
                    </div>
                    <div style={{ backgroundImage: `url(${cecho})` }}
                        className="card-index fleet p-3 d-flex align-items-end flex-column flex-lg-row justify-content-between text-white"
                        onclick="window.open('cechoii.html','_self')">
                        <span className="display-4">M/Y C-Echo II</span>
                        <div className="d-flex align-items-center">
                            <img className="px-4" src={Icon360} alt="360" />
                            <a href="contact.html" style={{ textDecoration: "none" }}><span style={{ fontSize: "26px" }} className="text-white">Schedule</span></a>
                        </div>
                    </div>
                </article>
            </section>

            <section className="text-white" style={{ backgroundColor: "#0e2a47" }}>
                <h1 className="text-center py-5">Alternative Safaris</h1>
                <article className="d-flex flex-column flex-lg-row justify-content-center align-items-center     pb-5 px-5">
                    <div className="d-flex flex-column">
                        <div style={{ backgroundImage: `url(${UltimateVacation})` }}
                            className="safari p-3 d-flex align-items-center justify-content-center text-white">
                        </div>
                        <span className="display-6 text-center">Ultimate Vacation</span>
                    </div>
                    <div className="d-flex flex-column">
                        <div style={{ backgroundImage: `url(${kite})` }}
                            className="safari p-3 mx-3 d-flex align-items-center justify-content-center text-white">
                        </div>
                        <span className="display-6 text-center">Kite Safari</span>
                    </div>
                    <div className="d-flex flex-column">
                        <div style={{ backgroundImage: `url(${wreck})` }}
                            className="safari p-3 mx-3 d-flex align-items-center justify-content-center text-white">
                        </div>
                        <span className="display-6 text-center">Wreck Exploration</span>
                    </div>
                </article>
            </section>

            <section className="d-flex flex-column flex-lg-row align-items-center pb-5 px-5 py-5 text-center">
                <div className="px-5">
                    <h1 className='titleHome'>Why us ?</h1>
                    <p>
                        With spacious cabins, delicious cuisine, and state-of-the-art facilities, our boats are the perfect
                        choice for travelers seeking a unique and unforgettable experience. Our experienced and knowledgeable
                        guides will lead you through the most breathtaking and remote corners of the Red Sea, taking you on a
                        journey that is both exhilarating and relaxing.
                    </p>
                    <p>
                        But don't just take our word for it. Our boats have been praised by countless satisfied customers
                        who have raved about the unparalleled level of service and attention to detail that we provide.
                        From families to solo adventurers, our boats are suitable for everyone. So why settle for a
                        typical beach vacation when you can embark on a once-in-a-lifetime adventure with Red Sea Safari
                        Tourism? Book your trip today and discover why our boats are the perfect choice for your next adventure.
                    </p>
                </div>
            </section>
            <Footer />
        </div>
    );
}